/*************
 * loginFormHandler
 * Form controller for Login Form.
 *
 * This script contains initialization of magnific Popup,
 * and contains panel hide/show logic.
 */

// Requires magnific to run
require('magnific-popup');

custom.loginFormHandler = (() => {
  const formId = 'login-form';
  const sectionClass = `js-${formId}-section`;
  const switcherClass = `js-${formId}-switcher`;
  const currentClass = 'current';
  const initializedClass = 'mfp-initialized';

  const forgotPwdId = 'ForgotPasswordForm';
  const forgotPwdIdPage = 'ForgotPasswordForm-1';
  const forgotPwdMsg = 'reset-password-message';

  const messages = {
    default: 'We’ll send you an email with a link to reset it.',
    success: "We've sent an email to reset it. Please check your inbox.",
    error:
      'Email does not match our records. Please email <a href="mailto:customerservice@loloirugs.com?subject=I%20need%20assistance%20with%20a%20login%20to%20loloirugs.com">customerservice@loloirugs.com</a> for assistance.',
  };

  // Error Handler
  function errorHandler(error) {
    return console.log('Error: ', error);
  }

  /******************
   * MODAL TRIGGER BINDINGS
   */

  // Bind the magnific popup handler to the trigger
  function inputPopupHandler(id) {
    const $trigger = $(`.js-${id}-trigger`);

    //loop through all items
    $trigger.each(function () {
      if (!$(this).hasClass(initializedClass)) {
        $(this).magnificPopup({
          type: 'inline',
          // Delay in milliseconds before popup is removed
          removalDelay: 600,

          // Class that is added to popup wrapper and background
          // make it unique to apply your CSS animations just to this exact popup
          mainClass: 'mfp-fade',
          callbacks: {
            beforeOpen: function () {
              $(this).addClass(initializedClass);
              custom.formLabelAnimation.init();
            },
          },
        });
      }
    });
  }

  /**
   * errorForgotPassword
   *
   * @param {object} error DOM object - list of errors
   */
  function errorForgotPassword($form = null) {
    const $emailInput = $form.find(`input[type="email"]`);
    const errorContainerSelector = $emailInput.data('parsley-errors-container');

    // Fake it as parsley error
    $emailInput.parent('.custom-input').addClass('parsley-error');
    $(errorContainerSelector).html(
      `<p class="type-utility-small-regular text-red mt-2">${messages.error}</p>`,
    );
  }

  /**
   * successForgotPassword
   *
   * @param {object} sucess response DOM object
   */
  function successForgotPassword($form = null) {
    const $emailInput = $form.find(`input[type="email"]`);
    const errorContainerSelector = $emailInput.data('parsley-errors-container');

    // Remove all existing error
    $emailInput.parent('.custom-input').removeClass('parsley-error');
    $(errorContainerSelector).empty();

    $(`#${forgotPwdId} .${forgotPwdMsg}`).text(messages.success);
    $(`#${forgotPwdId}`).addClass('success');
    $(`#${forgotPwdIdPage} .${forgotPwdMsg}`).text(messages.success);
    $(`#${forgotPwdIdPage}`).addClass('success');

    setTimeout(() => {
      $emailInput.val('');
      $(`#${forgotPwdId} .${forgotPwdMsg}`).text(messages.default);
      $(`#${forgotPwdId}`).removeClass('success');
      $(`#${forgotPwdIdPage} .${forgotPwdMsg}`).text(messages.default);
      $(`#${forgotPwdIdPage}`).removeClass('success');
    }, 5000);
  }

  /**
   * clearError
   *
   * Clears out all current errors when inputting
   * @param {object} event keydown event object
   */
  function clearError(event) {
    const $el = $(event.currentTarget);
    $el.parsley().reset();
    $el.parent('.custom-input').removeClass('parsley-error');
    $($el.data('parsley-errors-container')).empty();
  }

  /**
   * forgotPasswordHandler
   *
   * @param {object} event object - submit button click event
   *
   * NOTE: If our shopify app let this access customer data through API call, need to change response Handler logic, since now it gets response of full confirmation page
   */
  function submitForgotPassword(event = null) {
    event.preventDefault();
    const $form = $(this);
    if ($form.parsley().isValid()) {
      const email = $form.find(`[type="email"]`).val();

      window.MUAPP.customerExists(email).then((res) => {
        if (!res.shopify_customer) return errorForgotPassword($form);
        //if (window.MUAPP.flushCookie) window.MUAPP.flushCookie();
        if (res.shopify_customer_state == 'enabled') {
          return $.ajax({
            type: 'POST',
            url: '/account/recover',
            data: $form.serialize(),
            success: successForgotPassword($form),
            error: function (request, status, err) {
              errorHandler(err);
            },
          });
        } else {
          window.MUAPP.activateUser(res.shopify_id, () =>
            successForgotPassword($form),
          );
        }
      });
    }
  }

  /**
   * submitLoginForm
   *
   * @param {object} event object - submit form data
   *
   * NOTE: If our shopify app let this access customer data through API call, need to change response Handler logic, since now it gets resopnse of full confirmation page
   */
  function submitLoginForm(event = null) {
    event.preventDefault();
    const $form = $(this);
    const $submitButton = $form.find('.js-login-modal-submit-button');
    custom.utils.submitLoaderHandler($submitButton);
    return $.ajax({
      type: 'POST',
      dataType: 'html',
      url: $form.attr('action'),
      data: $form.serializeArray(),
      success: function (data, textStatus) {
        //Find account login page error listings by ID
        $errors = data.indexOf('loginErrorsPresent');
        if ($errors && $errors > -1) {
          //error present in response, login was not successful.
          errorSubmitLogin($form);
        } else {
          //login was a success, reload page is possible
          location.reload();
        }
      },
      error: function (request, status, err) {
        // 429 error - too many requests
        if (request.status == 429) {
          console.log('Error 429, resubmit form to get captcha');
          $form.unbind('submit').submit();
        } else {
          console.log(status + ', ' + err + ', ' + request);
          errorSubmitLogin($form);
        }
      },
    });
  }

  /**
   * errorSubmitLogin
   *
   * @param {object} error DOM object - form that had errors
   */
  function errorSubmitLogin($form = null) {
    const $submitButton = $form.find('.js-login-modal-submit-button');
    //Show animation for at least a split second
    setTimeout(function () {
      custom.utils.removeSubmitLoaderHandler(
        $submitButton,
        $submitButton.data('text'),
      );
    }, 250);
    const $errorsMessage = $form.find(`.js-submit-errors`);
    $errorsMessage.removeClass('hidden');
    const $inputs = $form.find(`.js-form-label-animation`);
    $inputs.addClass('error');
  }

  /**
   * sectionSwitcher
   *
   * @param {object} event object - Button or navigation link click event
   */
  function sectionSwitcher(event = null) {
    event.preventDefault();
    const selector = $(event.currentTarget).attr('href');

    const parentNodeId = $(event.currentTarget).closest(`#login-form-container`)
      .length
      ? 'login-form-container'
      : 'login-page';

    $(`#${parentNodeId} .${sectionClass}`).removeClass(currentClass);
    $(`#${parentNodeId} ${selector}`).addClass(currentClass);
  }

  function init() {
    inputPopupHandler(formId);
    $(`.${switcherClass}`).on('click', sectionSwitcher);

    $(`#${forgotPwdId} form`).parsley(custom.utils.parsleyOption());
    $(`#${forgotPwdId} form`).on('submit', submitForgotPassword);
    $(`#${forgotPwdId} form input`).on('keydown', clearError);
    $(`#${forgotPwdIdPage} form`).parsley(custom.utils.parsleyOption());
    $(`#${forgotPwdIdPage} form`).on('submit', submitForgotPassword);
    $(`#${forgotPwdIdPage} form input`).on('keydown', clearError);
    //Submit login form handled by ajax to prevent redirect to another page on failure.
    $(`.js-login-form--modal form`).on('submit', submitLoginForm);
  }

  return {
    init,
    inputPopupHandler,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/login-form-handler.js